import { useLocation } from "react-router-dom";

import HomeHeader from "../HomeHeader/HomeHeader";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import "./Layout.css";


const Layout = ({ children }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";

    return (
        <div className="layout-container">
            {isHomePage ? <HomeHeader /> : <Header />}
            <main className="main-content">
                {children}
            </main>
             <Footer/>
        </div>
    );
};

export default Layout;